import Amplify, { API, Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';

import createParams from '../lib/createApiParams';
import customFetch from '../lib/customFetch';

const apiName = 'xinerlink';
Amplify.configure(awsconfig);

async function getToken() {
  // @ts-ignore
  const { accessToken } = await Auth.currentSession();
  return accessToken.jwtToken;
}

// Funcion para simular un delay en la respuesta de la API. Para utilizarla en pruebas de frontend
// function delayTest({ tiempo = 5000, respuesta = null } = {}) {
//   console.log('Comienzo de la solicitud');
//   console.log({ respuesta, tiempo });
//   return new Promise((resolve) => setTimeout(() => resolve(respuesta), tiempo));
// }

const obtenerTrabajadores = async () => {
  try {
    const myInit = createParams();
    const res = await customFetch(() =>
      API.get('xinerlink', '/backoffice/v1/trabajador/verTrabajadores', myInit)
    );

    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const notificarComunidad = async (data) => {
  try {
    const myInit = createParams();
    myInit.body = {
      userToken: await getToken(),
      ...data,
    };
    console.log(myInit);
    const res = await customFetch(() =>
      API.post('xinerlink', '/backoffice/notificarComunidad', myInit)
    );

    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verTurnos = async ({ rut, desde, hasta }) => {
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    rut,
    desde,
    hasta,
  };
  const res = customFetch(() =>
    API.get(apiName, '/backoffice/v1/verTurnos', myInit)
  );
  return res;
};

const obtenerContratosObraFaena = async ({ estadoContrato }) => {
  if (['Activo', 'Inactivo', ''].includes(estadoContrato) === false) {
    console.error(
      'El estado del contrato debe ser Activo, Inactivo o un string vacío'
    );
  }
  const myInit = createParams();
  myInit.queryStringParameters = {
    userToken: await getToken(),
    estadoContrato,
  };
  const res = customFetch(() =>
    API.get(
      apiName,
      '/backoffice/v1/contratoObraFaena/obtenerContratos',
      myInit
    )
  );
  return res;
};

const backofficeService = {
  obtenerTrabajadores,
  notificarComunidad,
  verTurnos,
  obtenerContratosObraFaena,
};

export default backofficeService;
